import { Injectable } from '@angular/core';
import {Observable } from 'rxjs/Rx';

import { RxHttp, RequestQueryParams, LookupAction } from '@rx/http';
import { AuthorizeApi} from "@rx/security";

import {  TechnicalTerm, } from 'src/app/database-models';
import { TechnicalTermLookupGroup } from './domain/technical-term.models';

@Injectable()
export class TechnicalTermsService {
   

	private get api(): AuthorizeApi {
        var authorizeApi: AuthorizeApi = {
            api: `api/TechnicalTerms`,
            applicationModuleId: 33,
            keyName:'technicalTermId'
	
        }
        return authorizeApi;
    }

    constructor(
        private http: RxHttp
    ) { }

    lookup<TechnicalTermLookupGroup>(lookupActions: LookupAction[]): Promise<TechnicalTermLookupGroup> {
        return this.http.lookup<TechnicalTermLookupGroup>(lookupActions);
    }

    group<TechnicalTermLookupGroup>(params: any[] | {
        [key: string]: any;
    } | RequestQueryParams, lookupActions: LookupAction[]): Promise<TechnicalTermLookupGroup> {
        return this.http.group<TechnicalTermLookupGroup>(this.api, params, 'technicalTerm', lookupActions);
    }

	search(search: any): Observable<TechnicalTerm[]> {
        return this.http.search<TechnicalTerm[]>(this.api, search);
    }

    get(): Observable<TechnicalTerm[]> {
        return this.http.get<TechnicalTerm[]>(this.api);
    }

    getBy(params?: any[] | {
        [key: string]: any;
    } | RequestQueryParams): Observable<TechnicalTerm> {
        return this.http.get<TechnicalTerm>(this.api, params); 
    }

    post(technicalTerm: TechnicalTerm): Observable<TechnicalTerm> {
        return this.http.post<TechnicalTerm>(this.api, technicalTerm);
    }

    put(technicalTerm: TechnicalTerm): Observable<TechnicalTerm> {
        return this.http.put<TechnicalTerm>(this.api, technicalTerm);
    }

    delete(id : number): Observable<TechnicalTerm> {
        return this.http.delete<TechnicalTerm>(this.api,id);
    }

	filterLookup<T>(lookup:LookupAction,filterParameters:any[],queryParams?: {[key:string]:any}):Observable<T> {
        return this.http.filterLookup(lookup,filterParameters,queryParams);
    }

}
